import { animate } from 'animejs-v4';
import { Bot } from 'lucide-react';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export function AiConversationNotice() {
  const { t } = useTranslation();
  const noticeRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const noticeElement = noticeRef.current;

    if (noticeElement === null) {
      return undefined;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return undefined;
    }

    const animation = animate(
      noticeElement.querySelectorAll<HTMLElement>('[data-ai-notice-item]'),
      {
        opacity: [0, 1],
        translateY: [12, 0],
        scale: [0.98, 1],
        delay: 100,
        duration: 520,
        ease: 'out(3)',
      },
    );

    return () => {
      animation.pause();
    };
  }, []);

  return (
    <aside
      ref={noticeRef}
      aria-label={t('HomePage.aiNotice.ariaLabel')}
      className="relative mt-6 flex w-full max-w-[30rem] items-center gap-3 overflow-hidden rounded-2xl border border-[#21c294]/30 bg-[#d1f7e3]/60 px-4 py-4 text-left shadow-[0_10px_30px_rgba(33,194,148,0.12)]"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-8 -top-8 size-28 rounded-full bg-[#21c294]/15 blur-2xl"
      />

      <div
        data-ai-notice-item
        className="relative flex size-10 shrink-0 items-center justify-center rounded-xl bg-[#21c294] text-white shadow-sm"
      >
        <Bot aria-hidden="true" className="size-5" strokeWidth={2.25} />
      </div>

      <p
        data-ai-notice-item
        className="relative m-0 flex flex-col gap-1 text-base font-semibold leading-6 text-[#254441] sm:text-lg sm:leading-7"
      >
        <span className="text-sm font-bold uppercase tracking-wider text-[#009f7f]">
          {t('HomePage.aiNotice.title')}
        </span>
        {t('HomePage.aiNotice.message')}
      </p>
    </aside>
  );
}
